import Slider from 'react-slick';
import { Box, IconButton } from '@mui/material';
import { useRef, useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import molegBanner from '@/assets/imgs/home/mainSlideBanners/01_법제처.png';
import mohwBanner from '@/assets/imgs/home/mainSlideBanners/02_행안부.png';
import niaBanner from '@/assets/imgs/home/mainSlideBanners/03_한국지능정보사회진흥원.png';
import korailBanner from '@/assets/imgs/home/mainSlideBanners/04_한국철도공사.png';
import atBanner from '@/assets/imgs/home/mainSlideBanners/05_한국농수산유통공사.png';
import srBanner from '@/assets/imgs/home/mainSlideBanners/06_에스알.png';
import startupBanner from '@/assets/imgs/home/mainSlideBanners/07_창업진흥원.png';
import komscoBanner from '@/assets/imgs/home/mainSlideBanners/08_한국조폐공사.png';
import fscBanner from '@/assets/imgs/home/mainSlideBanners/09_금융위원회.png';
import mofaBanner from '@/assets/imgs/home/mainSlideBanners/10_외교부.png';
import ntsBanner from '@/assets/imgs/home/mainSlideBanners/11_국세청.png';
import nccBanner from '@/assets/imgs/home/mainSlideBanners/12_국립암센터.png';
import necBanner from '@/assets/imgs/home/mainSlideBanners/13_중앙선거관리위원회.png';
import mwfBanner from '@/assets/imgs/home/mainSlideBanners/14_여성가족부.png';
import ssnBanner from '@/assets/imgs/home/mainSlideBanners/15_사회복지공동모금회_사랑의열매.png';
import acrcBanner from '@/assets/imgs/home/mainSlideBanners/16_국민권익위원회.png';
import ktptiBanner from '@/assets/imgs/home/mainSlideBanners/17_무역안보관리원.png';
import seoulMetroBanner from '@/assets/imgs/home/mainSlideBanners/18_서울교통공사.png';
import mlitBanner from '@/assets/imgs/home/mainSlideBanners/19_국토교통부.png';
import tsBanner from '@/assets/imgs/home/mainSlideBanners/20_한국교통안전공단.png';

const logoList = [
  { alt: '법제처', src: molegBanner },
  { alt: '행정안전부', src: mohwBanner },
  { alt: '한국지능정보사회진흥원', src: niaBanner },
  { alt: '한국철도공사', src: korailBanner },
  { alt: '한국농수산식품유통공사', src: atBanner },
  { alt: '㈜에스알', src: srBanner },
  { alt: '창업진흥원', src: startupBanner },
  { alt: '한국조폐공사', src: komscoBanner },
  { alt: '금융위원회', src: fscBanner },
  { alt: '외교부', src: mofaBanner },
  { alt: '국세청', src: ntsBanner },
  { alt: '국립암센터', src: nccBanner },
  { alt: '선거관리위원회', src: necBanner },
  { alt: '여성가족부', src: mwfBanner },
  { alt: '사회복지공동모금회', src: ssnBanner },
  { alt: '국민권익위원회', src: acrcBanner },
  { alt: '무역안보관리원', src: ktptiBanner },
  { alt: '서울교통공사', src: seoulMetroBanner },
  { alt: '국토교통부', src: mlitBanner },
  { alt: '한국교통안전공단', src: tsBanner },
];

const settings = {
  // infinite: true,
  // slidesToShow: 1,
  // slidesToScroll: 1,
  // autoplay: true,
  // autoplaySpeed: 3000,
  // arrows: false, // 내부 화살표 숨김
  // dots: false,
  // cssEase: 'linear', // 부드럽게 이동

  // variableWidth: true, // 각 아이템 너비 고정
  // pauseOnHover: false, // 마우스 올려도 멈추지 않게
  className: 'slider variable-width',
  arrows: false, // 배너 스타일에서는 화살표 없음
  dots: false, // 점도 없음
  infinite: true, // 무한 반복
  speed: 3000, // 하나 넘기는 데 8초 걸림
  autoplay: true, // 자동 재생
  autoplaySpeed: 0, // autoplay 간격 0 = 끊기지 않음
  cssEase: 'linear', // 부드럽게 이동
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true, // 각 아이템 너비 고정
  pauseOnHover: false, // 마우스 올려도 멈추지 않게
};

export default function LogoCarousel() {
  const sliderRef = useRef<Slider>(null);

  return (
    <Box
      sx={{
        '.slick-slide': {
          padding: '0 8px', // ← 슬라이드 간 간격 확보
        },
      }}
    >
      <Slider ref={sliderRef} {...settings}>
        {logoList.map((logo, index) => (
          <Box
            key={index}
            sx={{
              padding: '0.5rem 1rem',
              display: 'flex !important',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              width: {
                xs: '160px !important',
                md: '280px !important',
              },
              height: {
                xs: '52px !important',
                md: '70px !important',
              },
              border: '1px solid',
              borderImageSource: 'linear-gradient(180deg, #1F3F78 0%, #264F97 52.88%, #1F3F78 100%)',
              background: 'rgba(255, 255, 255, 0.20)',
              backdropFilter: 'blur(4px)',
            }}
          >
            <Box
              component={'img'}
              src={logo.src}
              alt={logo.alt}
              sx={{
                width: 'auto',
                height: {
                  xs: '32px',
                  md: '50px',
                },
                maxHeight: '50px',
                display: 'block',
              }}
            ></Box>
          </Box>
        ))}
      </Slider>
    </Box>
  );
}
